import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6932bd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-name text-wrap" }
const _hoisted_2 = { key: 5 }
const _hoisted_3 = {
  key: 1,
  class: "player-name text-wrap ringbearer"
}
const _hoisted_4 = {
  key: 1,
  class: "profile-info"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Comunidad:", -1))
const _hoisted_6 = {
  key: 3,
  class: "profile-info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nick LGDA:", -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 5,
  class: "profile-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ciudad:", -1))
const _hoisted_11 = {
  key: 7,
  class: "profile-info"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1))
const _hoisted_13 = {
  key: 9,
  class: "profile-info"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fecha de nacimiento:", -1))
const _hoisted_15 = {
  key: 11,
  class: "profile-info"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Teléfono:", -1))

import {
  ref,
  reactive,
  onMounted,
  computed,
  withDefaults,
} from "vue";
import { UsuarioViewDTO, EditarUsuarioDTO } from "@/interfaces/Usuario";
import { convertirFecha } from "@/utils/Fecha";
import { getFacciones } from "@/services/FaccionesService";
import { editarUsuario } from "@/services/UsuariosService";
import { FaccionDTO } from "@/interfaces/Faccion";
import defaultAvatar from "@/assets/icons/perfil.png";
import ModalCambiarPass from "./ModalCambiarPass.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardPerfilUsuario',
  props: {
    user: {},
    selectedFaccionName: {},
    editable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const isEditing = ref(false);
const editableUser = reactive({ ...props.user });
const editableFaccionName = ref<string>("");
const faccionesCombo = ref<FaccionDTO[]>([]);
const faccionSelected = ref<number>();
const datePickerMenu = ref<boolean>(false);
const showModalCambiarPass = ref<boolean>(false);

const dateObject = ref<Date>(); // Aquí guardamos la fecha como objeto Date

// Convertir `dateObject` de vuelta a `YYYY-MM-DD` cuando el usuario seleccione una fecha
const updateFechaNacimiento = (date: Date) => {
  dateObject.value = date;
  editableUser.fechaNacimiento = date.toISOString().split("T")[0]; // Formato YYYY-MM-DD
  datePickerMenu.value = false;
};

// Computed para mostrar siempre la fecha correctamente en el input
const formattedFechaNacimiento = computed({
  get: () =>
    dateObject.value ? dateObject.value.toISOString().split("T")[0] : "",
  set: (value) => {
    if (value) {
      dateObject.value = new Date(value);
    }
  },
});

const toggleEditMode = () => {
  isEditing.value = !isEditing.value;
};

const handlerCambiarPass = () => {
  showModalCambiarPass.value = true;
};

const closeModalCambiarPass = () => {
  showModalCambiarPass.value = false;
};

const logFaccionSelection = (value: FaccionDTO) => {
  // Buscar la facción seleccionada en el array de facciones
  const foundFaccion = faccionesCombo.value.find(
    (f) => f.idFaccion === value.idFaccion
  );

  if (foundFaccion) {
    editableFaccionName.value = foundFaccion.nombreFaccion; // ✅ Solo guarda el nombre
    faccionSelected.value = foundFaccion.idFaccion; // ✅ Guarda el ID
  }
};

const saveChanges = async () => {
  isEditing.value = false;

  let editusu: EditarUsuarioDTO = {
    idUsuario: props.user.idUsuario,
    nombreUsuario: editableUser.nombreUsuario,
    primerApellido: editableUser.primerApellido,
    segundoApellido: editableUser.segundoApellido,
    nuevoEmail: editableUser.email,
    idFaccion: faccionSelected.value,
    fechaNacimiento: editableUser.fechaNacimiento,
    telefono: editableUser.telefono,
    nickLGDA: editableUser.nickLGDA,
    ciudad: editableUser.ciudad,
    imagen: editableUser.imagen, // Se envía la imagen en base64
    nick: editableUser.nick,
  };

  try {
    await editarUsuario(editusu);
  } catch (error) {
    console.error("Error al editar usuario: "), error;
  }
};

const handleImageUpload = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    editableUser.imagen = reader.result as string;
  };
};

onMounted(async () => {
  try {
    const faccionesResponse = await getFacciones();
    faccionesCombo.value = faccionesResponse.data.map((f: FaccionDTO) => ({
      idFaccion: f.idFaccion,
      nombreFaccion: f.nombreFaccion,
    }));
    // Preseleccionar la facción del usuario
    if (props.selectedFaccionName) {
      const foundFaccion = faccionesCombo.value.find(
        (f) => f.idFaccion === props.selectedFaccionName
      );
      if (foundFaccion) {
        editableFaccionName.value = foundFaccion.nombreFaccion;
        faccionSelected.value = foundFaccion.idFaccion;
      }
    }
  } catch (error) {
    console.error("Error al obtener las facciones:", error);
  }

  if (editableUser.fechaNacimiento) {
    dateObject.value = new Date(editableUser.fechaNacimiento);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { class: "profile-section" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_avatar, {
          size: "120",
          class: "avatar"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: editableUser.imagen || _unref(defaultAvatar),
              alt: "Avatar"
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        (isEditing.value)
          ? (_openBlock(), _createBlock(_component_v_file_input, {
              key: 0,
              accept: "image/*",
              label: "Subir nueva imagen",
              onChange: handleImageUpload,
              variant: "solo",
              dense: ""
            }))
          : _createCommentVNode("", true),
        _createElementVNode("h2", _hoisted_1, [
          (isEditing.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: toggleEditMode,
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isEditing.value)
            ? (_openBlock(), _createBlock(_component_v_text_field, {
                key: 1,
                modelValue: editableUser.nick,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableUser.nick) = $event)),
                label: "Nick",
                dense: "",
                variant: "solo"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (isEditing.value)
            ? (_openBlock(), _createBlock(_component_v_text_field, {
                key: 2,
                modelValue: editableUser.nombreUsuario,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editableUser.nombreUsuario) = $event)),
                label: "Nombre",
                dense: "",
                variant: "solo"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (isEditing.value)
            ? (_openBlock(), _createBlock(_component_v_text_field, {
                key: 3,
                modelValue: editableUser.primerApellido,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableUser.primerApellido) = $event)),
                label: "Primer apellido",
                dense: "",
                variant: "solo"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (isEditing.value)
            ? (_openBlock(), _createBlock(_component_v_text_field, {
                key: 4,
                modelValue: editableUser.segundoApellido,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editableUser.segundoApellido) = $event)),
                label: "Segundo apellido",
                dense: "",
                variant: "solo"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (!isEditing.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _createTextVNode(_toDisplayString(editableUser.nombreUsuario) + " " + _toDisplayString(editableUser.primerApellido) + " " + _toDisplayString(editableUser.segundoApellido) + " ", 1),
                (_ctx.editable)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      icon: "",
                      onClick: toggleEditMode
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "x-small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-pen")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!isEditing.value)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(editableUser.nick), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider, { class: "mb-3" }),
        _createVNode(_component_v_card_text, { class: "mt-0 text-left" }, {
          default: _withCtx(() => [
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_combobox, {
                  key: 0,
                  modelValue: editableFaccionName.value,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((editableFaccionName).value = $event)),
                    logFaccionSelection
                  ],
                  items: faccionesCombo.value,
                  "item-title": "nombreFaccion",
                  "item-value": "idFaccion",
                  label: "Selecciona una comunidad"
                }, null, 8, ["modelValue", "items"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(editableFaccionName.value), 1)
                ])),
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 2,
                  modelValue: editableUser.nickLGDA,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editableUser.nickLGDA) = $event)),
                  label: "Nick LGDA",
                  dense: "",
                  variant: "solo"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("a", {
                    href: 
            'https://www.laguerradelanillo.com/tu-perfil/' +
            editableUser.nickLGDA
          ,
                    target: "_blank"
                  }, _toDisplayString(editableUser.nickLGDA), 9, _hoisted_8)
                ])),
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 4,
                  modelValue: editableUser.ciudad,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editableUser.ciudad) = $event)),
                  label: "Ciudad",
                  dense: "",
                  variant: "solo"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(editableUser.ciudad), 1)
                ])),
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 6,
                  modelValue: editableUser.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editableUser.email) = $event)),
                  label: "Email",
                  dense: "",
                  variant: "solo"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(editableUser.email), 1)
                ])),
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_menu, {
                  key: 8,
                  modelValue: datePickerMenu.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((datePickerMenu).value = $event)),
                  "close-on-content-click": false,
                  transition: "scale-transition",
                  "offset-y": ""
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_text_field, _mergeProps(props, {
                      modelValue: formattedFechaNacimiento.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formattedFechaNacimiento).value = $event)),
                      label: "Fecha de nacimiento",
                      "prepend-icon": "mdi-calendar",
                      readonly: "",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (datePickerMenu.value = true))
                    }), null, 16, ["modelValue"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_date_picker, {
                      modelValue: dateObject.value,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((dateObject).value = $event)),
                        updateFechaNacimiento
                      ]
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(_unref(convertirFecha)(editableUser.fechaNacimiento)), 1)
                ])),
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 10,
                  modelValue: editableUser.telefono,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editableUser.telefono) = $event)),
                  label: "Teléfono",
                  dense: "",
                  variant: "solo"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                  (_ctx.editable)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(editableUser.telefono), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (isEditing.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 12,
                  color: "primary",
                  variant: "tonal",
                  block: "",
                  onClick: saveChanges
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Guardar")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.editable)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "profile-section mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "tonal",
              color: "primary",
              onClick: handlerCambiarPass
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cambiar Contraseña ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showModalCambiarPass.value)
      ? (_openBlock(), _createBlock(ModalCambiarPass, {
          key: 1,
          onClose: closeModalCambiarPass
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})